import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges
} from "@angular/core";
import {
  FilterCollection,
  FilterSingleSelect,
  FilterValue,
  FilterValueCollection
} from "@hub/generated/models";

@Component({
  selector: "f-filterSearch",
  templateUrl: "./filterSearch.component.html",
  styleUrls: ["./filterSearch.component.scss"]
})
export class FilterSearchComponent implements OnInit, OnChanges {
  @Input()
  public filter: FilterSingleSelect;

  @Input() filterPlaceholderText: string = "Search...";

  private _filterCollection: FilterCollection;

  @Input()  set filterCollection(f: FilterCollection) {
      this._filterCollection = f;
      this.value = this.getValue();      
  }
  get filterCollection() {
      return this._filterCollection;
  }

  @Output()
  ondataChange: EventEmitter<FilterValueCollection> = new EventEmitter<
    FilterValueCollection
  >();

  value: string;
  columnName: string;

  ngOnInit() {
    this.columnName = this.filter.ColumnName;
    this.value = this.getValue();
  }

  ngOnChanges() {
    this.columnName = this.filter.ColumnName;
    this.value = this.getValue();
  }

  getFilterPlaceholder() {
    return !!this.filterPlaceholderText
      ? this.filterPlaceholderText
      : "Search...";
  }

  onSearch() {
    let result: FilterValueCollection = new FilterValueCollection();
    result.ColumnName = this.columnName;
    if (!!this.value) {
      let filterValue: FilterValue = { Key: "1", Value: this.value, EntityType: null };
      result.List = [filterValue];
    } else {
      result.List = [];
    }

    this.ondataChange.emit(result);
  }

  private getValue(): string {
    if (!!this.filterCollection && !!this.filterCollection.List) {
      let values = this.filterCollection.List.filter(
        item => item.ColumnName == this.columnName
      )[0];
      if (!!values && !!values.List && !!values.List.length)
        return values.List[0].Value;
    }

    return null;
  }
}
